/** 与 ConversationWorkflow 底部模型列表保持一致 */
export const WORKFLOW_MODEL_OPTIONS = [
  {
    id: 'agent',
    kind: 'image',
    name: 'Agent',
    desc: '一键 Agent 或 Agent² 完成剧本→分镜→出图→视频',
    badge: 'New',
    icon: 'fas fa-robot'
  },
  // {
  //   id: 'nano-2',
  //   kind: 'image',
  //   name: 'Nano 2',
  //   desc: '速度快，综合生图最好',
  //   icon: 'fas fa-bolt'
  // },
  // {
  //   id: 'midjourney-nij7',
  //   kind: 'image',
  //   name: 'Midjourney nij7',
  //   desc: '动漫美学最佳，无角色参考',
  //   icon: 'fas fa-hat-wizard'
  // },
  // {
  //   id: 'nano-pro',
  //   kind: 'image',
  //   name: 'Nano Pro',
  //   desc: '综合生图能力最好',
  //   badge: 'Best',
  //   icon: 'fas fa-crown'
  // },
  {
    id: 'seedream-5',
    kind: 'image',
    name: 'Seedream 5.0',
    desc: '最懂亚洲人审美，理解能力更强',
    icon: 'fas fa-wave-square'
  },
  {
    id: 'character-designer',
    kind: 'image',
    name: '角色设计图',
    desc: '角色三视图/服装变体/色板/表情/动作',
    badge: 'New',
    icon: 'fas fa-user-astronaut'
  },
  {
    id: 'script-writer',
    kind: 'text',
    name: '剧本创作',
    desc: '生成剧本/分镜/台词',
    badge: 'New',
    icon: 'fas fa-pen-nib'
  },
  {
    id: 'seedance-video',
    kind: 'video',
    name: 'Seedance',
    desc: '文生视频任务',
    icon: 'fas fa-video'
  }
]

export const DEFAULT_WORKFLOW_MODEL_ID = 'agent'
